import {ContentListProps} from 'presentation/components/StyledCard/types';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {formatText, getFlowTypeByBookingType} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

import {MyAppointmentsEnum} from 'presentation/constants';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {UseHealthDuplicityBookedCardProps} from './types';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {TELEMEDICINE_INFO} from 'presentation/modules/booking/shared/constants/telemedicineInfo';

export function useHealthDuplicityBookedCard({
	scheduledBooking,
}: UseHealthDuplicityBookedCardProps) {
	const navigate = useNavigate();
	const {userName} = useAccountInformation();

	const {color, variant, iconName} = useBookingTheme({
		flowType: getFlowTypeByBookingType(scheduledBooking.bookingType),
	});

	const bookingTypeIsTelemedicine = scheduledBooking.bookingType === BookingTypeEnum.TELEHEALTH;

	const handleGoToDetails = () => {
		const path = bookingTypeIsTelemedicine
			? MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_TELEHEALTH
			: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_HEALTH;

		navigate(path.replace(':id', scheduledBooking.bookingNumber));
	};

	const headerIconName = bookingTypeIsTelemedicine ? 'remember-me-filled' : iconName;

	const CONTENT_LIST: ContentListProps[] = [
		{
			primaryText: formatText(userName),
			iconName: 'account-circle-filled',
		},
		{
			primaryText: formatText(scheduledBooking.providerName),
			secondaryText: formatText(scheduledBooking.specialtyName),
			secondaryTextColor: 'text.secondary',
			iconName: 'medical-services-filled',
		},
		{
			primaryText: bookingTypeIsTelemedicine
				? formatText(TELEMEDICINE_INFO.name)
				: formatText(scheduledBooking.clinicName),
			iconName: bookingTypeIsTelemedicine ? 'remember-me-filled' : 'location-on-filled',
		},
	];

	return {
		handleGoToDetails,
		CONTENT_LIST,
		color,
		variant,
		headerIconName,
	};
}
